
const authRoutes = [
  {
    path: "/custom_fields",
    name: "ListCustomField",
    meta:{
      auth: true,
      translated: "Personalizados",
      permission: { act: "read", on: "CustomField" },
    },
    component: () => import("./pages/CustomFields.vue"),
    children: [
      {
        path: "/custom_fields/edit/:id",
        name: "EditCustomField",
        meta:{
          auth: true,
          translated: "Personalizados",
          permission: { act: "update", on: "CustomField" },
        },
        component: () => import("./components/custom_field/DialogNewCustomField.vue"),
      },
    ]
  },
  {
    path: "/custom_fields/:id",
    name: "OneCustomField",
    meta:{
      auth: true,
      translated: "Personalizados",
      permission: { act: "read", on: "CustomValue" },
    },
    component: () => import("./pages/OneCustomField.vue"),
    children: [
      {
        path: "/custom_fields/custom_value/edit/:cv_id",
        name: "EditCustomValue",
        meta:{
          auth: true,
          translated: "Personalizados",
          permission: { act: "update", on: "CustomValue" },
        },
        component: () => import("./components/custom_value/DialogCustomValue.vue"),
      },
    ]
  },
];

export default authRoutes;
